




























import { Component, Vue, Prop } from "vue-property-decorator";
import { Section } from "@/common/interface";
import store from "@/store";
import { Getter, Action } from "vuex-class";
import DashLine from "@/components/common/edit/DashLine.vue";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import DistributionRadio from "./DistributionRadio.vue";
import DistributeModeExplanation from './DistributeModeExplanation.vue';

@Component({
  components: {
    "activity-label": ActivityLabel,
    "dash-line": DashLine,
    "distribution-radio": DistributionRadio,
    "distribution-mode-explanation": DistributeModeExplanation
  },
})
export default class ActivityDistributeMode extends Vue {
  @Action("changeDistributeParameter") changeDistributeParameter!: Function;
  @Action("changeShowFooter") changeShowFooter!: Function;

  get sectionConf() {
    return store.getters.section;
  }
  openDistributeModeModal() {
    this.changeDistributeParameter({'openDistributeModeModal':true});
    this.changeShowFooter(false);
  }
}
